import {SuccessEvent} from "../../../../../../common/ts/core/http";
import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../../../common/ts/events/Events";
import {TrovitPageData} from "../../../TrovitPageData";

interface SaveWebPushAlertRequestedPayload {
    search: TrovitPageData,
    subscription: PushSubscription,
    successEvent?: SuccessEvent,
}

export class SaveWebPushAlertRequestedEvent implements WhitelabelEventWithPayload<SaveWebPushAlertRequestedPayload> {
    payload: SaveWebPushAlertRequestedPayload;
    type: string;
    static readonly TYPE: string = 'save-web-push-alert-requested';

    constructor(payload: SaveWebPushAlertRequestedPayload) {
        this.type = SaveWebPushAlertRequestedEvent.TYPE;
        this.payload = payload;
    }
}

interface WPNRequestedPayload {
    pageData: TrovitPageData,
    eventType: String,
    userId?: String,
    successEvent?: SuccessEvent,
}

export class WPNPermissionsEvent implements WhitelabelEvent {
    payload: WPNRequestedPayload;
    type: string;
    static readonly TYPE: string = 'wl-wpn-permissions';

    constructor(payload: WPNRequestedPayload) {
        this.type = WPNPermissionsEvent.TYPE;
        this.payload = payload;
    }
}
